module.exports = __webpack_public_path__ + "img/map_pc_5.aee64396.png";